import wcShared from '@web-components/shared';

import { InitStore } from './Stores/init-store';
import { MessagesStore } from './Stores/messages-store';
import { SectionStore } from './Stores/section-store';
import { Store } from './Stores/store';

class HelpdeskCommon {
  loadingInit2 = false;

  htmlEntities(str: string) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  urlFormatFaq(text?: string, id?: number) {
    let url = '';
    if (Boolean(text)) {
      url += '&search=' + this.htmlEntities(text);
    } else if (Boolean(id)) {
      url += '&id=' + id;
    } else {
      const project = window['PROJECT_SLUG'] || window['CURRENT_PROJECT'];
      const route = window['CURRENT_ROUTE'];
      let service_id = window['SERVICE_ID'];
      if (!service_id) {
        service_id = window['CURRENT_SERVICE_ID'];
      }
      const category_id = window['CATEGORY_ID'];
      if (project) {
        url += '&project=' + this.htmlEntities(project);
      }
      if (route) {
        url += '&route=' + this.htmlEntities(route);
      } else if (['hosting2', 'hosting3'].includes(window['CURRENT_PROJECT'])) {
        url += '&route=home';
      }
      if (service_id && Number.isInteger(service_id) && service_id > 0) {
        url += '&service_id=' + parseInt(service_id);
      }
      if (category_id && Number.isInteger(category_id) && category_id > 0) {
        url += '&category_id=' + parseInt(category_id);
      }
    }
    return url;
  }

  getInit(): Promise<IWCInit> {
    if (this.loadingInit2) {
      return;
    }

    this.loadingInit2 = true;
    wcShared?.store?.loaderStart('loadingInit2');

    let url = `/api/components/chatbot/init?lang=${wcShared?.store?.getLang()}&with=phone,chat,support,tickets`;
    url += this.urlFormatFaq();

    return wcShared
      .httpCall('GET', url)
      .then((r) => {
        if (r.status === 200) {
          return r.json().then((response) => {
            wcShared?.store?.loaderStop('loadingInit2').then(() => (this.loadingInit2 = false));
            InitStore.set('init', {
              ...InitStore.get('init'),
              phone: response.data.phone,
              chat: response.data.chat,
              code: response.data.code,
              support: response.data.support,
            });
            return response.data;
          });
        }
      })
      .catch(() => {
        wcShared?.store?.loaderStop('loadingInit2').then(() => (this.loadingInit2 = false));
      });
  }

  hasScroll() {
    const componentHeight = document
      ?.querySelector('module-helpdesk-component')
      ?.shadowRoot?.querySelector('main-helpdesk-switch-component')?.offsetHeight;
    let myElement: HTMLElement | number;

    // Change for scroll header version for Contact
    if (
      SectionStore?.get('section')?.contact_list ||
      SectionStore?.get('section')?.contact_mail_error ||
      SectionStore?.get('section')?.contact_mail ||
      SectionStore?.get('section')?.contact_mail_success
    ) {
      setTimeout(() => {
        myElement = document
          ?.querySelector('module-helpdesk-component')
          ?.shadowRoot?.querySelector('main-helpdesk-switch-component')
          ?.shadowRoot?.querySelector('contact-module')?.offsetHeight;

        Store?.set('hasScroll', myElement + 200 >= componentHeight);
      }, 100);
    }
    // Change for scroll header version for Chat
    else if (SectionStore?.get('section')?.chat) {
      setTimeout(() => {
        const allElements = document
          ?.querySelector('module-helpdesk-component')
          ?.shadowRoot?.querySelector('main-helpdesk-switch-component')
          ?.shadowRoot?.querySelector('bot-component')
          ?.shadowRoot?.querySelector('bot-messages-component')
          ?.shadowRoot?.querySelectorAll('bot-message-component');

        myElement = allElements?.[allElements?.length - 1];
        myElement = myElement?.offsetHeight + myElement?.offsetTop;
        Store?.set('hasScroll', myElement + 200 >= componentHeight);
      }, 100);
    }
  }

  resetConversation() {
    if (Store?.get('loaderResetConversation')) {
      return;
    }

    Store?.set('loaderResetConversation', true);

    let url = `/api/components/chatbot/reset?lang=${wcShared?.store?.getLang()}`;
    url += this.urlFormatFaq();

    return wcShared
      .httpCall('GET', url)
      .then((r) => {
        if (r.status === 200) {
          return r.json().then((response) => {
            Store?.set('bot_id', response.data.bot_id);
            Store?.set('channel_id', response.data.channel_id);

            MessagesStore?.set('messages', response?.data?.messages);
            Store?.set('is_active', true);
            InitStore.set('init', {
              ...InitStore.get('init'),
              continue_event: true,
            });

            Store?.set('loaderResetConversation', false);
            Store?.set('displayModal', false);
            Store?.set('typeModal', null);
          });
        }
      })
      .catch((err) => {
        Store?.set('loaderResetConversation', false);
        Store?.set('displayModal', false);
        Store?.set('typeModal', null);
        console.error(err);
      });
  }
}

export default new HelpdeskCommon();
